import { useState } from "react";
import logger from '../utils/logger';

export const useLoader = (callback) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const fetching = async () => {
        try {
            setIsLoading(true);
            await callback();
        } catch (error) {
            setError(error.message);
            logger.log('Ошибка из useLoader');
            logger.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    return [fetching, isLoading, error];
};
